import React from 'react';
import { levels, semesterWeeks } from '../data/semester';

/** The full 16-week semester plan as a 4×4 grid with level-track dots. */
export function SemesterGrid() {
  return <div className="rounded-2xl border border-amber/40 bg-night-800 p-3 sm:p-6" data-id="element-336" data-mp="25uv9ewftqm8o">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between" data-id="element-337" data-mp="25wpm5ngxz81o">
        <div data-id="element-338" data-mp="21ve5i7g1px5m">
          <p className="text-[10px] font-semibold uppercase tracking-label text-amber sm:text-[11px]" data-id="element-339" data-mp="21vnmx6n0yvzp">
            Plan semestru
          </p>
          <p className="mt-1 font-display text-xl leading-none text-cream sm:text-3xl" data-id="element-340" data-mp="195np1rqxyj6c">
            16 tygodni · gotowe
          </p>
        </div>
        <ul className="flex flex-wrap gap-x-4 gap-y-1.5" aria-label="Legenda poziomów" data-id="element-341" data-mp="1n2ap43e6xpgh">
          {levels.map(level => <li key={level.key} className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-cream-soft sm:text-[11px]" data-id="element-342" data-mp="2yjaeor95lq6t">
              <span className={`h-2 w-2 rounded-full ${level.dotClass}`} aria-hidden="true" data-id="element-343" data-mp="33oiyj1zcsv9d" />
              {level.label}
            </li>)}
        </ul>
      </div>
      <ol className="mt-4 grid grid-cols-4 gap-1.5 sm:mt-5 sm:gap-2.5" data-id="element-344" data-mp="37rxdrqfgx7lr">
        {semesterWeeks.map((topic, index) => <li key={topic} className="flex min-h-[4.75rem] flex-col rounded-lg border border-night-600 bg-night-900 p-1.5 sm:min-h-[6.5rem] sm:p-3" data-id="element-345" data-mp="3hns477pxo6z3" data-mpi={index}>
            <span className="text-[8px] font-bold uppercase tracking-[0.04em] text-amber sm:text-[10px] sm:tracking-[0.14em]" data-id="element-346" data-mp="2jyfawjowxerj">
              Tydzień {index + 1}
            </span>
            <span className="mt-1 line-clamp-3 text-[10px] font-medium leading-tight text-cream sm:mt-1.5 sm:text-sm sm:leading-snug" data-id="element-347" data-mp="2tx4ucgwgj79w">
              {topic}
            </span>
            <span className="mt-auto flex gap-1 pt-1.5" aria-hidden="true" data-id="element-348" data-mp="218z9zv9bfkal">
              {levels.map(level => <span key={level.key} className={`h-1.5 w-1.5 rounded-full sm:h-2 sm:w-2 ${level.dotClass}`} data-id="element-349" data-mp="2670rwcv09dkh" />)}
            </span>
          </li>)}
      </ol>
    </div>;
}